import { gql } from '@eti/schema-types';

export const SELECT_TRIP = gql(/* GraphQL */ `
  mutation SelectTripOnYourSelectedTripPage(
    $selectionKey: String!
    $extraProductSelection: [ID]
    $bundleProductSelection: [BundleSelectionInput]
    $searchPath: String
  ) {
    selectTrip(
      selectionKey: $selectionKey
      extraProductSelection: $extraProductSelection
      bundleProductSelection: $bundleProductSelection
      searchPath: $searchPath
    ) {
      success
    }
  }
`);
